webpackJsonp([5471959507512],{

/***/ 1716:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"Comment","kind":"OBJECT","type":"OBJECT","fields":[{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"body","type":{"kind":"SCALAR","name":"String","ofType":null}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"id","type":{"kind":"SCALAR","name":"ID","ofType":null}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"insertedAt","type":{"kind":"SCALAR","name":"NaiveDateTime","ofType":null}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"provider","type":{"kind":"OBJECT","name":"Provider","ofType":null}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"updatedAt","type":{"kind":"SCALAR","name":"NaiveDateTime","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---object-comment-8a114c813549abcbaa64.js